import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconNewsStyle0 = cosmosIconCss;

const CosmosIconNews$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconNews extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '5f07098917076a6b96fd605f2800dc220eaa3bdd', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'edd29baa1f634d5092cae7abf5b602767be48f51', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '667b13dc06f15741c97dfb2d40c01499c96077c9', d: "M16.25 4a.75.75 0 0 1 .75.75v2.5h2.25c.398 0 .75.352.75.75v7.75A2.262 2.262 0 0 1 17.75 18H4.25A2.262 2.262 0 0 1 2 15.75v-11A.75.75 0 0 1 2.75 4h13.5Zm-.75 1.5h-12v10.25c0 .428.322.75.75.75h11.39a2.201 2.201 0 0 1-.14-.75V5.5Zm3 3.25H17v7c0 .428.322.75.75.75s.75-.322.75-.75v-7Z", fill: "currentColor" }), h("path", { key: '677f77c6075595aae2689475c3adcb8f3416894b', d: "M10 8.25a.5.5 0 0 1-.5.5h-4a.495.495 0 0 1-.5-.5v-.5a.5.5 0 0 1 .5-.5h4a.508.508 0 0 1 .5.5v.5Zm4 3a.5.5 0 0 1-.5.5h-8a.495.495 0 0 1-.5-.5v-.5a.5.5 0 0 1 .5-.5h8a.508.508 0 0 1 .5.5v.5Zm0 3a.5.5 0 0 1-.5.5h-8a.495.495 0 0 1-.5-.5v-.5a.5.5 0 0 1 .5-.5h8a.508.508 0 0 1 .5.5v.5Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconNewsStyle0; }
}, [1, "cosmos-icon-news", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-news"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-news":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconNews$1);
            }
            break;
    } });
}

const CosmosIconNews = CosmosIconNews$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconNews, defineCustomElement };
